(function () {
  const COIN_RATE = 3; // Coins pro Euro

  function calcCoins(priceCents) {
    return Math.floor((priceCents / 100) * COIN_RATE);
  }

  function setCoinValue(scope, priceCents) {
    const targets = (scope || document).querySelectorAll('[data-ms-coins][data-ms-context="pdp"] [data-ms-coins-value]');
    targets.forEach((el) => { el.textContent = calcCoins(priceCents); });
  }

  // PDP – Variant Change abfangen (Symmetry-kompatibel + Fallbacks)
  ['variant:change', 'variantChange', 'product:variant:change'].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      const v = e.detail && (e.detail.variant || e.detail);
      if (v && typeof v.price !== 'undefined') {
        const scope = e.target && e.target.closest ? e.target.closest('main, .product, [data-section-type="product"]') : document;
        setCoinValue(scope, v.price);
      }
    });
  });

  // Fallback: input[name="id"] change → fetch variant
  document.addEventListener('change', function (e) {
    const el = e.target;
    if (el && el.matches('select[name="id"], input[name="id"]')) {
      const form = el.closest('form');
      const productHandle = form && form.dataset && form.dataset.productHandle;
      const variantId = el.value;
      if (!variantId) return;
      // Variant-Daten aus product-json holen
      const scope = el.closest('main, .product, [data-section-type="product"]') || document;
      const dataEl = scope.querySelector('[data-product-json], script[type="application/json"][data-product]');
      if (dataEl) {
        try {
          const data = JSON.parse(dataEl.textContent);
          const v = (data.variants || []).find((x) => String(x.id) === String(variantId));
          if (v) setCoinValue(scope, v.price);
        } catch (err) { /* silent */ }
      }
    }
  });
})();